import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/32.png';
import _imports_2 from '../../../assets/new/49.png';
import _imports_3 from '../../../assets/new/9.png';
import _imports_4 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-10016bf0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "为了匹配阅读等级，请完善你的信息！", -1));
const _hoisted_6 = {
  class: "list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年级", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("请选择"), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "班级", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("请选择"), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_12 = [_hoisted_10, _hoisted_11];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button"
}, "完成", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "6rem"
  }
}, null, -1));
const _hoisted_15 = {
  class: "footer"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
import { ref } from "vue";
import { useRouter } from "vue-router";
import { getLocalPid } from "../../../libs/util";
export default {
  __name: 'classInfo_copy',
  setup(__props) {
    const showPicker = ref(false);
    const pid = getLocalPid();
    const router = useRouter();
    const columns = ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华"];
    const onConfirm = () => {
      showPicker.value = false;
    };
    return (_ctx, _cache) => {
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_4), _createTextVNode(" 设置班级信息 ")]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "item",
        onClick: _cache[1] || (_cache[1] = $event => showPicker.value = true)
      }, _hoisted_9), _createElementVNode("div", {
        class: "item",
        onClick: _cache[2] || (_cache[2] = $event => showPicker.value = true)
      }, _hoisted_12)]), _hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_16, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_17, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_18, _createTextVNode(" 个人中心 ")])])]), _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => showPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: columns,
          onCancel: _cache[6] || (_cache[6] = $event => showPicker.value = false),
          onConfirm: onConfirm
        })]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};